import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-bootstrap'
import EditValue from '../EditValue'

class Unchanged extends Component {
  static propTypes = {
    cell: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    inDict: PropTypes.bool,
    updatedBy: PropTypes.string
  }

  getTooltip = () => {
    const { cell, updatedBy } = this.props
    return (
      <Tooltip id={`description-${cell}`}>
        {cell ? cell.toString() : ''}
        {updatedBy && (
          <span className="edited-by-user label-capitalize">
            <br />
            <i>{`Updated By: ${updatedBy}`}</i>
          </span>
        )}
      </Tooltip>
    )
  }

  render() {
    return (
      <EditValue getTooltip={() => this.getTooltip()}>
        <span className={this.props.inDict ? 'in-dict' : 'not-in-dict'}>
          {this.props.cell ? this.props.cell.toString() : ''}
        </span>
      </EditValue>
    )
  }
}

export default Unchanged
